import { render, staticRenderFns } from "./UserCardWithPopover.vue?vue&type=template&id=4feacd4f"
import script from "./UserCardWithPopover.vue?vue&type=script&lang=js"
export * from "./UserCardWithPopover.vue?vue&type=script&lang=js"
import style0 from "./UserCardWithPopover.vue?vue&type=style&index=0&id=4feacd4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports